module.exports = __webpack_public_path__ + "img/img24.c36c59e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img24.png
// module id = 201
// module chunks = 0